import { useCustomFields } from 'admin/customFields/hooks/useCustomFields';
import { Actions, Subjects } from 'permissions/ability';
import { useAbility } from 'permissions/hooks/useAbility';

export const useEditAvailable = () => {
  const ability = useAbility();
  const editingTagAvailable = ability.can(Actions.edit, Subjects.tags);
  const canEditCustomField = ability.can(Actions.read, Subjects.customFields);
  const { customFields } = useCustomFields();
  const editingCustomFieldAvailable =
    canEditCustomField && !!customFields && customFields.length > 0;

  return editingTagAvailable || editingCustomFieldAvailable;
};
